const SUPPORT_WHATSAPP_NUMBER = '5531990198760';

export function buildSupportWhatsappUrl(message) {
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function buildUpgradeWhatsappUrl({ accountName, planName, whatsappUpgradeUrl } = {}) {
  if (whatsappUpgradeUrl) return whatsappUpgradeUrl;
  const account = accountName ? ` da conta ${accountName}` : '';
  const plan = planName ? ` (plano atual: ${planName})` : '';
  const text =
    `Olá! Preciso fazer um upgrade do plano do PedeGo${account}${plan}. ` +
    'Gostaria de aumentar o limite da IA avançada com chat ou mudar de plano.';
  return buildSupportWhatsappUrl(text);
}

export function buildBlockedAccountWhatsappUrl({ accountName, accountId } = {}) {
  const accountLabel = accountName
    ? `${accountName}${accountId ? ` (ID ${accountId})` : ''}`
    : accountId
      ? `ID ${accountId}`
      : '';
  const accountPart = accountLabel ? ` Conta: ${accountLabel}.` : '';
  const text =
    `Olá! Minha conta do PedeGo está com o acesso suspenso e gostaria de resolver.${accountPart} ` +
    'Podem me ajudar, por favor?';
  return buildSupportWhatsappUrl(text);
}

export function formatPlanPrice(priceCents, currency = 'BRL') {
  if (priceCents == null) return '—';
  return (priceCents / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: currency || 'BRL',
  });
}
